<ul *rxLet="index$; let currentIndex" class="thumbnails">
	<li
		class="thumb"
		*rxFor="
	      let thumb of thumbnails$; 
	      trackBy: trackById;
	      let i = index;
	    "
	    [@leaveAnimation]
	    [libScrollIntoViewIfActive]="i === currentIndex"
	>
		<a
			class="thumb-link"
			[routerLink]="thumb.url" 
			routerLinkActive="active"
			title="{{ thumb.title }}"
		>
		<lib-icon 
			class="icon-video"
			name="play" 
			*rxIf="thumb.video"
		></lib-icon>
		</a>
	</li>
</ul>
